import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { TrainingOnRequest } from "@/components/TrainingOnRequest";
import { RelatedLinks } from "@/components/RelatedLinks";
import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/data/site";

export default function BookingsPage() {
  usePageMeta(
    "Bookings · Training On Request",
    "Bespoke USDD training for schools, organisations, festivals, youth programmes, team building and creative workshops. Tailored proposals within 48 hours."
  );
  return (
    <>
      <Header />
      <main>
        <PageHero
          overline="06 · Training On Request"
          title="Book USDD for"
          highlight="your team."
          description="From one-off masterclasses to multi-week residencies, we design and deliver bespoke training for schools, organisations, festivals, youth programmes, team-building experiences and creative workshops. One brief, one team, one unforgettable session."
          ctaPrimary={{ label: "Request a Quote", to: "/contact" }}
          ctaSecondary={{ label: "Enquire Now", to: "/contact" }}
          bg={SITE.classImg6}
        />
        <TrainingOnRequest />
        <RelatedLinks
          title="Related"
          items={[
            { tag: "Adults", label: "Weekly Training", desc: "Open public classes", to: "/training" },
            { tag: "Workshops", label: "Cultural Workshops", desc: "Festivals & community", to: "/workshops" },
            { tag: "Events", label: "Events & Battles", desc: "Showcases & competitions", to: "/events" },
          ]}
        />
      </main>
      <Footer />
    </>
  );
}
